import React from 'react'
import { BsInstagram, BsGithub } from 'react-icons/bs'
import { FaLinkedin } from 'react-icons/fa'

const SocialMedia = () => {
  return (
    <div className='app__social'>
		<div>
			<a href="https://www.linkedin.com/in/muklasnurardiansyah/" target="_blank" rel="noopener noreferrer"><FaLinkedin/></a>
		</div>
		<div>
			<a href="https://instagram.com/iam_muklas" target="_blank" rel="noopener noreferrer"><BsInstagram/></a>
		</div>
		<div>
			<a href="https://github.com/klaseeee" target="_blank" rel="noopener noreferrer"><BsGithub/></a>
		</div>
    </div>
  )
}

export default SocialMedia